import { User, UserGridPreferencesDto } from '../graphql/types';

export function getUserProfileFullName(user: Partial<User>) {
  return [user?.data?.firstName || user?.name, user?.data?.lastName].filter(Boolean).join(' ');
}

export function getUserProfileDropdown(user: Partial<User>) {
  return [user?.data?.firstName || user?.name, user?.data?.lastName, user?.email, user?.company?.legalName].filter(Boolean).join('');
}

export function getUserProfileWithCompany(user: Partial<User>) {
  const fullName = getUserProfileFullName(user);
  const company = user?.company?.legalName;

  return company ? `${fullName} (${company})` : fullName;
}

export function applyAgGridPreferences(user: Partial<User>) {
  const savedPreferences = user?.gridPreferences?.filter((pref: UserGridPreferencesDto) => pref.active) || [];
  savedPreferences.forEach((sp: UserGridPreferencesDto) => {
    const keyName = sp.keyName || `${user.id}_${sp.key}`;
    if (!localStorage.getItem(keyName + '_COLUMNS_STATE')) {
      localStorage.setItem(keyName + '_COLUMNS_STATE', sp.columnsState);
      localStorage.setItem(keyName + '_FILTER_STATE', sp.filterState);
      localStorage.setItem(keyName + '_USE_SCROLL', sp.useScroll ? 'true' : 'false');
    }
  });
}
